module.exports = __webpack_public_path__ + "img/vxe.7fbdb2c1.png";